// services/LearnToRankService.js
import axios from '@fs/zion-axios'
import { baseUrl } from '@fs/zion-config'

/**
 * Calls the real Solr search endpoint for Learn to Rank.
 * @param {string} query - The search text (e.g., "yuma az").
 * @returns {Promise<{results: Array}>} - Object with a `results` array.
 */
export const solrSearch = async (query) => {
  const text = (query || '').trim()
  if (!text) {
    return { results: [] }
  }

  const placeServiceBase = `${baseUrl || ''}/service/standards/place/ws-ui`
  const url = `${placeServiceBase}/places/solr-search`

  const response = await axios.get(url, {
    params: {
      text,
      limit: 50,
      output: 'summary',
      partial: true,
    },
    placesAPI: true,
    fsUserAgentChainSuffix: 'zion-standards',
  })

  const data = response.data || {}

  // Flatten all hits from all searchResults
  const rawResults = (data.searchResults || []).flatMap((sr) => sr?.result || []) || []

  // 🔁 Normalize into the shape your UI expects
  const results = rawResults.map((r) => {
    const rep = r.rep || {}
    const displayName = rep.display?.name || ''
    const fullDisplayName = rep.fullDisplay?.name

    return {
      id: rep.id,
      displayName,
      fullDisplayName,
      // ADD BOTH SCORES HERE
      rawScore: r.rawScore ?? null,
      relevanceScore: r.relevanceScore ?? null,
      // Keep your existing UI-friendly fields:
      names: [rep.display?.name].filter(Boolean),

      // keep full objects in case you need more later
      rep,
      tokenMatches: r.tokenMatches,
    }
  })

  return { results }
}
